import { useSelector, useDispatch } from "react-redux";
import { Route, Switch, useRouteMatch } from "react-router";
import { IneligibleScreen } from "../../EligibilityCheckerGeneric/ResultScreens";
import Bmi from "./Bmi";
import { useHistory } from "react-router-dom";
import { Pages } from "../../../../data/eligibilityChecker/loseWeight/pages";
import { OnARoll } from "../../EligibilityCheckerGeneric";
import { update_signup_form_values } from "../../../../store/actions/signupFlowData";
import { pageTitleSuffix } from "../../../../data/eligibilityChecker";
import { loseWeightPageTitle } from "../../../../data/Programme";
import { ProgrammeProps } from "../../EligibilityCheckerGeneric/Props";

export interface BmiProps extends ProgrammeProps {
  height: string;
  weight: string;
}
function BmiRoot({ height, weight }: Readonly<BmiProps>) {
  let { path } = useRouteMatch();
  const history = useHistory();
  const dispatch = useDispatch();
  const signupValues = useSelector((state: any) => state.signupFlowData.signupFormValues);
  const BmiPageData = useSelector((state: any) => state.signupFlowData.signupPagesData?.bmi);
  const offeredSupported = signupValues?.offeredSupported;
  const offeredDigital = signupValues?.offeredDigital;
  const nextStepUrl = "/pathway";
  const ineligibleBmiPageTitle = `Ineligible BMI | ${loseWeightPageTitle} | ${pageTitleSuffix}`;

  const handleOnARollPageClick = () => {
    if (offeredSupported && offeredDigital) {
      history.push(nextStepUrl);
    } else if (offeredSupported && !offeredDigital) {
      dispatch(update_signup_form_values({ pathway: "Supported" }));
      history.push(nextStepUrl);
    } else {
      dispatch(update_signup_form_values({ pathway: "Digital" }));
      history.push(nextStepUrl);
    }
  };

  return (
    <Switch>
      <Route exact path={`${path}`}>
        <Bmi height={height} weight={weight} programmeTitle={loseWeightPageTitle}></Bmi>
      </Route>

      <Route path={`${path}/bmitoolow`}>
        <IneligibleScreen
          title={ineligibleBmiPageTitle}
          heading={BmiPageData.ineligibleScreens?.bmiTooLow?.title}
          bodyText={BmiPageData.ineligibleScreens?.bmiTooLow?.body}
          hasContactUs={true}
        />
      </Route>
      <Route path={`${path}/bmitoohigh`}>
        <IneligibleScreen
          title={ineligibleBmiPageTitle}
          heading={BmiPageData.ineligibleScreens?.bmiTooHigh?.title}
          bodyText={BmiPageData.ineligibleScreens?.bmiTooHigh?.body}
          hasContactUs={true}
        />
      </Route>
      <Route path={`${path}/success`}>
        <OnARoll pageRedirectionLogicOrNextStepUrl={handleOnARollPageClick} onARollPageData={Pages.onARoll} />
      </Route>
    </Switch>
  );
}

export default BmiRoot;
